import { motion } from 'framer-motion'
import { BookOpen, Users, Briefcase, FileText, BarChart3, ShieldCheck } from 'lucide-react'

const NotreHistoire = () => {
  const sections = [
    {
      title: "Organisation",
      icon: <BookOpen className="text-cidh-gold" size={32} />,
      content: (
        <div className="space-y-4 text-gray-600 leading-relaxed text-lg">
          <p>
            Créé en octobre 2007, le <span className="font-bold text-cidh-blue">Centre International pour le Développement Humain</span> en abrégé <span className="font-bold text-cidh-blue">CIDH Consulting SARL</span> est une structure privée spécialisée dans les domaines de la formation, des études et conseils, mettant ses compétences et son savoir-faire au bénéfice des Entreprises, des Administrations, des Collectivités locales, des OPA, des groupements tant du secteur formel qu’informel.
          </p>
          <p>
            Le centre embauche 13 employés permanents, tous déclarés à la CNPS et emploie plus de 70 experts-consultants à temps partiel pour des missions précises. Le cabinet CIDH Consulting SARL est géré par un Directeur Général et comprend une direction de la formation et quatre (04) Services.
          </p>
        </div>
      )
    },
    {
      title: "La Direction de la Formation",
      icon: <Users className="text-cidh-gold" size={32} />,
      content: (
        <div className="space-y-4">
          <p className="text-gray-600 leading-relaxed">
            Elle est chargée de conduire la politique de formation du cabinet à travers la coordination et la gestion des offres auprès des différents entreprises et partenaires. Elle est composée de deux services :
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
            <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-cidh-blue">
              <h4 className="font-bold text-cidh-blue mb-2">Le Service commercial</h4>
              <p className="text-sm text-gray-600">
                Interface entre l’entreprise et le marché cible. Il prospecte, vend les services et l’image de l’entreprise et gère l’information commerciale.
              </p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm border-l-4 border-cidh-gold">
              <h4 className="font-bold text-cidh-blue mb-2">Le Service de programmation et suivi clientèle</h4>
              <p className="text-sm text-gray-600">
                Chargé de la mise en œuvre des plans de formation, de l’exécution des modules (programmation, déroulement) et de l’évaluation de la satisfaction.
              </p>
            </div>
          </div>
        </div>
      )
    },
    {
      title: "Le Service Administratif et Financier",
      icon: <ShieldCheck className="text-cidh-gold" size={32} />,
      content: (
        <div className="space-y-4 text-gray-600 leading-relaxed">
          <p>
            Ce service joue un rôle de supervision, d’organisation et de coordination de l'ensemble de la fonction comptabilité - secrétariat. Il adapte les procédures du cabinet en fonction de l'évolution de la réglementation en vigueur.
          </p>
          <div className="bg-cidh-blue/5 p-6 rounded-2xl border border-cidh-blue/10">
            <p className="mb-4 font-medium text-cidh-blue">Missions clés :</p>
            <ul className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <li className="flex gap-2 items-start text-sm">
                <span className="w-1.5 h-1.5 bg-cidh-gold rounded-full mt-1.5 shrink-0"></span>
                <span>Gestion des ressources humaines et relations organismes sociaux.</span>
              </li>
              <li className="flex gap-2 items-start text-sm">
                <span className="w-1.5 h-1.5 bg-cidh-gold rounded-full mt-1.5 shrink-0"></span>
                <span>Enregistrement et traitement des mouvements financiers.</span>
              </li>
              <li className="flex gap-2 items-start text-sm">
                <span className="w-1.5 h-1.5 bg-cidh-gold rounded-full mt-1.5 shrink-0"></span>
                <span>Conseil à la Direction sur les prévisions et stratégies à moyen terme.</span>
              </li>
              <li className="flex gap-2 items-start text-sm">
                <span className="w-1.5 h-1.5 bg-cidh-gold rounded-full mt-1.5 shrink-0"></span>
                <span>Analyse des coûts et de la rentabilité pour optimiser la gestion.</span>
              </li>
            </ul>
          </div>
        </div>
      )
    },
    {
      title: "Le Service Études et Projets",
      icon: <BarChart3 className="text-cidh-gold" size={32} />,
      content: (
        <div className="space-y-4 text-gray-600 leading-relaxed">
          <p>
            Ce service est chargé de rédiger les appels d’offres et les études à la demande des structures privées et publiques. Il conduit l’exécution de projets /programmes et études sur le terrain.
          </p>
          <div className="flex flex-col md:flex-row gap-6 mt-4">
            <div className="flex-1 p-6 bg-gray-50 rounded-xl">
              <div className="flex items-center gap-3 mb-3">
                <FileText className="text-cidh-blue" size={24} />
                <h4 className="font-bold text-cidh-blue">Études & Appels d'offres</h4>
              </div>
              <p className="text-sm">Conception technique et réponse aux sollicitations des partenaires publics et privés.</p>
            </div>
            <div className="flex-1 p-6 bg-gray-50 rounded-xl">
              <div className="flex items-center gap-3 mb-3">
                <Briefcase className="text-cidh-blue" size={24} />
                <h4 className="font-bold text-cidh-blue">Gestion de Projets</h4>
              </div>
              <p className="text-sm">Préparation, animation d'équipe, gestion des imprévus et bilan final des interventions terrain.</p>
            </div>
          </div>
        </div>
      )
    }
  ]

  return (
    <div className="pt-24 pb-16 min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-cidh-blue py-20 mb-16 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 right-0 w-96 h-96 bg-cidh-gold rounded-full -mr-48 -mt-48 blur-3xl"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-cidh-gold rounded-full -ml-48 -mb-48 blur-3xl"></div>
        </div>
        <div className="container mx-auto px-4 md:px-6 relative z-10 text-center">
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl md:text-5xl font-bold text-white mb-6 font-montserrat"
          >
            Notre Histoire & Organisation
          </motion.h1>
          <motion.div 
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            className="w-24 h-1.5 bg-cidh-gold mx-auto mb-10"
          ></motion.div>
          <motion.p 
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
            className="text-xl text-blue-100 max-w-3xl mx-auto leading-relaxed"
          >
            Découvrez le parcours, les structures et les femmes et hommes qui font l'excellence de CIDH Consulting depuis 2007.
          </motion.p>
        </div>
      </section>

      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-5xl mx-auto space-y-24">
          {sections.map((section, index) => (
            <motion.section 
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className={`flex flex-col ${index % 2 !== 0 ? 'md:flex-row-reverse' : 'md:flex-row'} gap-12 items-start`}
            >
              <div className="w-16 h-16 rounded-2xl bg-cidh-gray-light flex items-center justify-center shrink-0 shadow-sm border border-gray-100">
                {section.icon}
              </div>
              <div className="flex-grow">
                <h2 className="text-3xl font-bold text-cidh-blue mb-8 font-montserrat relative inline-block">
                  {section.title}
                  <span className="absolute -bottom-2 left-0 w-12 h-1 bg-cidh-gold rounded-full"></span>
                </h2>
                {section.content}
              </div>
            </motion.section>
          ))}
        </div>
      </div>
    </div>
  )
}

export default NotreHistoire
